import * as React from "react";
import SearchQueryHighlights from "../SearchQueryHighlights";
const DecoratorContext = React.createContext([SearchQueryHighlights]);
export default DecoratorContext;
